"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const Error = ({ message }) => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: message }, void 0) }, void 0));
};
exports.Error = Error;
const Wrapper = styled_components_1.default.div `
  flex: 1;
  display: flex;
  justify-content: center;
  margin-top: 8rem;
`;
//# sourceMappingURL=index.js.map